import { useCopilotoStatus, useDefinirAcoesCopiloto } from '@/api/copiloto';
import { ApiError } from '@/lib/api';

function mensagemErro(e: unknown): string {
  return e instanceof ApiError ? `${e.message}${e.code ? ` (${e.code})` : ''}` : 'falha de comunicação com a API';
}

/**
 * Empresa > Parametros > Copiloto com ações: liga as ações do Copiloto nesta empresa. So aparece quando a env
 * (COPILOTO_ACOES) permite (acoesDisponiveis). `editavel` vem de parametros.editar (quem decide e o pai); sem ela, ve o estado desabilitado.
 */
export function AcoesCopilotoEmpresa({ editavel }: { editavel: boolean }) {
  const status = useCopilotoStatus();
  const definir = useDefinirAcoesCopiloto();
  if (status.data?.acoesDisponiveis !== true) return null;
  const ligado = status.data.acoes;
  const erro = definir.isError ? mensagemErro(definir.error) : null;

  return (
    <section aria-label="Copiloto com ações" data-testid="secao-acoes-copiloto" className="flex flex-col gap-4 rounded-2xl border border-border bg-card p-5">
      <div>
        <h2 className="text-title font-semibold">Copiloto com ações</h2>
        <p className="mt-1 text-small text-ink-secondary">Deixa o Copiloto preparar ações (criar orçamento, lançar CIF...). Nada é gravado sem o seu clique em Confirmar.</p>
      </div>
      <label className="flex items-center gap-3 text-small">
        <input
          type="checkbox"
          role="switch"
          className="size-[18px] accent-primary"
          checked={ligado}
          disabled={!editavel || definir.isPending}
          onChange={(ev) => definir.mutate({ ligado: ev.target.checked })}
        />
        Ligar as ações do Copiloto nesta empresa
      </label>
      {!editavel && (
        <p role="note" className="text-caption text-ink-muted">
          Só quem edita os parâmetros da empresa liga ou desliga as ações do Copiloto.
        </p>
      )}
      {erro && (
        <p role="alert" className="text-small text-danger-ink">
          {erro}
        </p>
      )}
    </section>
  );
}
